import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';
import React from 'react';

export default function FolderIcon(props: SvgIconProps) {
   return (
      <SvgIcon {...props} viewBox="0 0 64 64">
         <g fill="#d69661">
            <path d="M52.48 14c2.498 0 4.52 2.224 4.52 4.978v31.04c0 2.746-2.02 4.979-4.52 4.979H11.516C9.024 54.997 7 52.765 7 50.018V18.269c0-2.754 2.02-4.272 4.516-4.272" />
            <path d="M22.26 8c.842 0 1.525.75 1.525 1.68l10 10.709c0 .926-.684 1.678-1.525 1.678H8.522c-.84 0-1.521-.752-1.521-1.678V9.68c0-.93.682-1.68 1.521-1.68z" />
         </g>
         <rect x="0" y="0" width="64" height="64" fill="rgba(0, 0, 0, 0)" />
         <g fill="#d69661">
            <path d="M52.48 14c2.498 0 4.52 2.224 4.52 4.978v31.04c0 2.746-2.02 4.979-4.52 4.979H11.516C9.024 54.997 7 52.765 7 50.018V18.269c0-2.754 2.02-4.272 4.516-4.272" />
            <path d="M22.26 8c.842 0 1.525.75 1.525 1.68l10 10.709c0 .926-.684 1.678-1.525 1.678H8.522c-.84 0-1.521-.752-1.521-1.678V9.68c0-.93.682-1.68 1.521-1.68z" />
         </g>
         <rect x="0" y="0" width="64" height="64" fill="rgba(0, 0, 0, 0)" />
      </SvgIcon>
   );
}
